export default [
  'en',
  'fr',
  'ja',
  'de',
  'ko',
  'es',
  'it',
  'pt',
  'zh',
  'zh-cn',
  'zh-tw',
  'tr',
  'id',
  'ru',
];
